import template from './_successful.pug'

// @vue/component
export default {
  template: template(),
  methods: {
    onBack() {
      this.$emit('deregister-finished')
    }
  }
}
